<template>
  <div>
    <input v-model="pseudo" placeholder="Pseudo">
    <input v-model="token" placeholder="Token">
    <button @click="validate">Enregistrer</button>
  </div>
</template>

<script>
export default {
  name: 'Login',
  props: {
    pseudo: String,
    token: String
  },
  methods: {
    validate() {
      window.localStorage.setItem('pseudo', this.pseudo);
      window.localStorage.setItem('token', this.token);
      this.redirect();
    },
    redirect() {
      const redirectUrl = this.$route.query && this.$route && this.$route.query.redirectUrl ? `${this.$route.query.redirectUrl}${this.$route.query.redirectUrl.includes('?') ? '&' : '?'}pseudo=${window.localStorage.getItem('pseudo')}&token=${window.localStorage.getItem('token')}` : 'http://google.com';
      window.location = redirectUrl;
    }
  },
  mounted() {
    if (window.localStorage.getItem('pseudo') && window.localStorage.getItem('token')) {
      this.redirect();
    }
  }
}
</script>

<style scoped>
</style>
